import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {changeSearchTitle, validateAndSetName} from '../../actions/searchesList';
import {SEARCH_NAME_MAX_LENGTH} from '../../consts/searches';
import EnhancedTitleInput from './TitleInputComp';

@observer
export class TitleInput extends Component<any, any> {
    onTitleChange = event => {
        const {searchesStore} = this.props;
        if (event.target.value.length <= SEARCH_NAME_MAX_LENGTH) {
            searchesStore.generatorSelected.setNewName(event.target.value);
        }
    };

    onSave = () => {
        const {searchesStore, finishEditing} = this.props;
        validateAndSetName(searchesStore.generatorSelected);
        changeSearchTitle(searchesStore.generatorSelected);
        finishEditing();
    };

    onClear = () => {
        const {searchesStore} = this.props;
        searchesStore.generatorSelected.setNewName('');
    };

    handleClickOutside = e => {
        e.stopPropagation();
        this.onSave();
    };

    handleEsc = e => {
        e.stopPropagation();
        this.onClear();
        this.onSave();
    };

    render() {
        const {searchesStore} = this.props;
        const {generatorSelected} = searchesStore;
        const {filtersCounter} = generatorSelected;

        return (
            <EnhancedTitleInput
                filtersCounter={filtersCounter}
                handleClickOutside={this.handleClickOutside}
                onChange={this.onTitleChange}
                onSave={this.onSave}
                onClear={this.onClear}
                value={generatorSelected.newName}
                onEnterKeyDown={this.handleClickOutside}
                onEscKeyDown={this.handleEsc}
            />
        );
    }
}
